module.exports = __webpack_public_path__ + "img/bg-card-scb.09892cbd.png";